import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
  return {
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
    },
    textContainer: {
      flex: '1 1 auto',
      minWidth: 0,
      overflow: 'hidden',
      '& a': {
        display: 'block',
        minWidth: 0,
        overflow: 'hidden',
      },
    },
    text: {
      display: 'block',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    buttonWrapper: {
      flex: '0 0 auto',
    },
    iconButton: {
      marginInlineStart: theme.spacing(1),
      padding: theme.spacing(0.25),
    },
    icon: {
      fontSize: theme.typography.fontSize,
    },
  };
});
